<template>
    <div>
        <section id="content" class="section">
            <div class="container">
                <TituloPagina titulo="Editar Lead" />
                <div id="container" v-if="item">
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-3" v-if="false">
                            <div class="card card-personal">
                                <div class="card-content">
                                    <div class="center-xs">
                                        <avatar :src="cliente.pessoa.pessoa_avatar" :cliente="cliente" />
                                        <div class="card-title">{{ cliente.pessoa.pessoa_nome }}</div>
                                    </div>
                                </div>
                                <div class="card-content">
                                    <h5>Dados Pessoais</h5>
                                    <dl>
                                        <dt>Gênero</dt>
                                        <dd>{{ cliente.pessoa.pessoa_sexo ? generos[cliente.pessoa.pessoa_sexo] : 'Não informado' }}</dd>
                                        <dt>Estado Civil</dt>
                                        <dd>
                                            {{ cliente.pessoa.pessoa_estado_civil ? estadosCivis[cliente.pessoa.pessoa_estado_civil] : 'Não informado' }}
                                        </dd>
                                        <dt>Telefone</dt>
                                        <dd>{{ cliente.pessoa.pessoa_telefone | phone }}</dd>
                                        <dt>Celular</dt>
                                        <dd>
                                            <span v-if="cliente.pessoa.pessoa_celular">{{ cliente.pessoa.pessoa_celular | phone }}</span>
                                            <span v-else>Não informado</span>
                                        </dd>
                                        <dt>E-mail</dt>
                                        <dd>{{ cliente.pessoa.pessoa_email }}</dd>
                                        <dt>CPF</dt>
                                        <dd>{{ cliente.pessoa.pessoa_cpf | cpf }}</dd>
                                        <dt>Data Nascimento</dt>
                                        <dd>{{ cliente.pessoa.pessoa_data_nascimento | moment("DD/MM/YYYY") }}</dd>
                                    </dl>
                                    <template v-if="cliente.pessoa.endereco">
                                        <h5>Endereço</h5>
                                        <dl>
                                            <dt>CEP</dt>
                                            <dd>
                                                <span v-if="cliente.pessoa.endereco_cep">
                                                    {{ cliente.pessoa.endereco_cep | cep }}
                                                </span>
                                                <span v-else>
                                                    Não informado
                                                </span>
                                            </dd>
                                            <dt>Logradouro</dt>
                                            <dd>{{ cliente.pessoa.endereco_logradouro }}</dd>
                                            <dt>Nº</dt>
                                            <dd>{{ cliente.pessoa.endereco_numero || 'Não informado' }}</dd>
                                            <dt>Cidade</dt>
                                            <dd>{{ cliente.pessoa.endereco_cidade }}</dd>
                                            <dt>Estado</dt>
                                            <dd>{{ cliente.pessoa.endereco_estado }}</dd>
                                            <dt>Complemento</dt>
                                            <dd>{{ cliente.pessoa.endereco_complemento || '-' }}</dd>
                                        </dl>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md">
                            <div class="card-panel">
                                <form @submit.prevent="salvar">
                                    <formulario-pessoa
                                        :pessoa="cliente.pessoa"
                                        @input="atualizarPessoa" />
                                    <formulario-endereco
                                        id="endereco"
                                        :endereco="cliente.pessoa.endereco || {}"
                                        @input="atualizarEndereco" />

                                    <div class="end-xs">
                                        <button class="btn btn-default waves-effect waves-light" type="submit">Salvar</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<style>
    ul.tab-demo a.active {
        background-color: #00bcd42b !important;
        color: #00bcd4 !important;
        font-weight: bold !important;
    }
</style>
<script type="text/javascript">
import "@/../static/assets/css/custom/flex.css";

import TituloPagina from '@/components/common/TituloPagina'
import Anexo from '@/components/lead/Anexo'
import { get, put } from '@/helpers/api';
import Avatar from "@/components/common/cliente/Avatar.vue";
import FormularioEndereco from '@/components/common/FormularioEndereco';
import FormularioPessoa from '@/components/common/FormularioPessoa';
import Message from '@/helpers/message';

import Auth from '@/store/auth';


export default {
    data() {
        return {item: null}
    },
    components: {
        Avatar,
        TituloPagina,
        FormularioEndereco,
        FormularioPessoa
    },
    created() {

        const {pedidoId} = this.$route.params;

        this.$parent.$emit('showLoading', true);

        get(`pedido/${pedidoId}`).then((response) => {
            this.item = response.data.result.data;
            this.$parent.$emit('showLoading', false);
        });
    },

    computed: {
        usuarioLogadoCargo() {
            return Auth.getCargoUsuario();
        },

        cliente() {
            return this.item ? this.item.cliente_has_produto.cliente : {};
        },

        estadosCivis() {
            return {'V' : 'Viúvo', 'S' : 'Solteiro', 'D' : 'Divorciado'}
        },

        generos() {
            return {'F' : 'Feminino', 'M' : 'Masculino'}
        }
    },

    filters: {
        moment: (date, format) => {

            const result = moment(date);

            if (result.isValid()) {
                return result.format(format);
            } else if (date) {
                return date;
            }

            return 'Não informado';
        }
    },

    methods: {
        atualizarPessoa(pessoa) {

            this.$set(this.cliente, 'pessoa', {...this.cliente.pessoa, ...pessoa});
        },

        atualizarEndereco(endereco)
        {
            this.$set(this.cliente, 'pessoa', {...this.cliente.pessoa, ...endereco});
        },

        salvar()
        {

            this.$parent.$emit('showLoading', true);

            const dados = {...this.cliente.pessoa};

            if (dados.pessoa_data_nascimento) {
                dados.pessoa_data_nascimento = moment(dados.pessoa_data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD');
            }

            ['pessoa_cpf', 'pessoa_telefone', 'pessoa_celular', 'endereco_cep'].forEach(key => {
                if (typeof dados[key] === 'string') {
                    dados[key] = dados[key].replace(/\D+/g, '');
                }
            })

            put(`cliente/${this.cliente.cliente_id}`, dados).then((response) => {
                Message.messageSuccess('Cliente atualizado com sucesso.');
                this.$router.push({name: 'Dashboard'});
            }).catch(() => {
                Message.messageError('Erro ao atualizar o cliente.');
            })
            .finally(() => this.$parent.$emit('showLoading', false));
        }
    }
}
</script>




<style scoped lang="scss">

.card-profile-image-action{
    opacity: 0;
    height: 150px;
    width: 150px;
    border-radius: 50%;
    background-color: #1eb6dc;
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;

}
.card-profile-image-action:hover{
    opacity: .7;
}

dl{
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;


    dt, dd{
        // float: left;
        width: 50%;
        margin: 0;
        padding: 8px 0;

        &:not(:last-of-type) {
            border-bottom: 1px solid rgba(0, 0, 0, .15);
        }
    }

    dt{
        font-weight: bold;
        &::after{
            content: ':';
        }
    }

    dd{
        text-align: right;
        color: #777;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/lead/GerenciamentoLeadSimulador.vue